import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Variants } from "@dhl-official/stencil-library";
// eslint-disable-next-line import/no-cycle
import { Icon } from "root/libs/ui-components/src";
import checkmarkCircle from "icons/cx/checkmarkCircle.svg";
import cancelCircle from "icons/cx/cancelCircle.svg";
import ValidationMessage from "./ValidationMessage";
import { StyledIconWrapper, ValidationMessageContainer } from "../styled";

const ValidationFeedback = ({ fieldId, validation }) => {
  const hasvalidationMsg = !!validation?.message;
  return (
    <Fragment>
      <ValidationMessageContainer
        hasvalidationMsg={hasvalidationMsg}
        role="alert"
      >
        {hasvalidationMsg && (
          <ValidationMessage
            id={`${fieldId}_ValidationMessage`}
            message={validation.message}
            variant={validation.type}
          />
        )}
      </ValidationMessageContainer>
      {(validation?.type === Variants.invalid ||
        validation?.type === Variants.valid) && (
        <StyledIconWrapper
          id={`${fieldId}-validation-icon-${validation.type}`}
          variant={validation?.type === Variants.invalid ? "error" : "success"}
        >
          {validation?.type === Variants.invalid ? (
            <Icon icon={cancelCircle} />
          ) : (
            <Icon icon={checkmarkCircle} />
          )}
        </StyledIconWrapper>
      )}
    </Fragment>
  );
};

ValidationFeedback.defaultProps = {
  fieldId: "validation-feedback",
};

ValidationFeedback.propTypes = {
  /** Form Field Id */
  fieldId: PropTypes.string,
  validation: PropTypes.shape({
    type: PropTypes.oneOf(["valid", "invalid", "note"]).isRequired,
    message: PropTypes.string,
  }),
};

export default ValidationFeedback;
